import { track } from '@amplitude/analytics-browser';
import { AxiosRequestConfig } from 'axios';
import { AdditionalOptions } from '@helpers/request';
import auth from '@stores/auth';
import { eventTypes } from '@constants/eventTypes';
import timeTracker from '@helpers/timeTracker';

async function trackEvent(params: AxiosRequestConfig, additionalOptions?: AdditionalOptions) {
  const { user } = auth.getState();
  const { url, method } = params;
  timeTracker();

  const urlParams = additionalOptions?.urlParams;
  let itemId = urlParams?.id
    || urlParams?.userId
    || urlParams?.postId
    || urlParams?.commentId
    || urlParams?.gameId;

  if (
    eventTypes[url as string]
    && eventTypes[url as string][method as string]
    && (process.env.NODE_ENV === 'production')
  ) {
    if (typeof additionalOptions?.data === 'string' && JSON.parse(additionalOptions?.data).id) {
      itemId = JSON.parse(additionalOptions?.data).id;
    }
    track(eventTypes[url as string][method as string], {
      userId: user?.id,
      role: user?.role,
      email: user?.email,
      itemId: itemId as string
    });
  }
}

export const trackTime = async (workTime: number) => {
  if (workTime) {
    const { user } = auth.getState();
    await track(eventTypes['time']['set'], {
      userId: user?.id,
      role: user?.role,
      email: user?.email,
      workTime
    });
  }
}

export default trackEvent;